<template>
  <div v-if="_pType > 1">
    <img
      class="flag-image"
      :style="{ width: 50 * scale + 'px' }"
      v-if="imageUrl"
      :src="imageUrl"
    />
  </div>
</template>
<script>
export default {
  props: {
    curMeal: {
      type: Number,
      default: -1
    },
    pType: {
      type: Number,
      default: 0
    },
    type2: {
      type: Number,
      default: -1
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      imageList: [
        {
          url: '',
          curMeal: null,
          p_type: 1,
          type2: null
        },
        {
          url: 'ic_punch_in_observer_tag',
          curMeal: null,
          p_type: 7,
          type2: null
        },
        {
          url: 'ic_punch_in_breakfast_tag',
          curMeal: 0,
          p_type: 3,
          type2: null
        },
        {
          url: 'ic_punch_in_lunch_tag',
          curMeal: 1,
          p_type: 3,
          type2: null
        },
        {
          url: 'ic_punch_in_supper_tag',
          curMeal: 2,
          p_type: 3,
          type2: null
        },
        {
          url: 'ic_punch_in_extra_meal_tag',
          curMeal: 3,
          p_type: 3,
          type2: null
        },
        {
          url: 'ic_punch_in_all_tag',
          curMeal: null,
          p_type: 6,
          type2: null
        },
        {
          url: 'ic_punch_in_start_measure',
          type2: 0,
          p_type: 2,
          curMeal: null
        },
        {
          url: 'ic_punch_in_measure',
          type2: 1,
          p_type: 2,
          curMeal: null
        },
        {
          url: 'ic_punch_in_end_measure',
          type2: 2,
          p_type: 2,
          curMeal: null
        },
        {
          url: 'ic_punch_in_motion_tag',
          p_type: 4,
          curMeal: null,
          type2: null
        }
      ],
      imageUrl: '',
      _pType: 1,
      _curMeal: -1,
      _type2: -1
    }
  },
  watch: {
    pType(val) {
      this.init()
    },
    curMeal(val) {
      this.init()
    },
    type2(val) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this._pType = typeof this.pType === 'number' ? this.pType : 1
      this._curMeal = typeof this.curMeal === 'number' ? this.curMeal : -1
      this._type2 = typeof this.type2 === 'number' ? this.type2 : -1
      for (let i = 0; i < this.imageList.length; i++) {
        let item = this.imageList[i]
        if (
          item.p_type == this._pType &&
          (item.curMeal == this._curMeal || item.curMeal === null) &&
          (item.type2 == this._type2 || item.type2 === null)
        ) {
          // this.imageUrl = item.url;
          this.imageUrl = require('@/assets/imgs/nutritionist-tool/' +
            item.url +
            '.png')
          return
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.flag-text {
  white-space: nowrap;
  font-size: 12px;
  position: absolute;
  left: 50%;
  bottom: -40px;
  transform: translate(-50%);
  color: #fff;
}
.flag-image {
  width: 50px;
}
</style>
